export const environment = {
  production: true,
  apiRoot: 'https://dolmatch-test.deimos.ch/api'
};
